import { ProjectModel } from '../types';
import {
    MySupervisionsAction,
    MySupervisionsActionType,
} from '../actionTypes/mySupervisions';

export interface MySupervisionsState {
    projects: Array<ProjectModel>;
}
export const INITIAL_MY_SUPERVISIONS: MySupervisionsState = {
    projects: [],
};

const reducer = (
    state: MySupervisionsState = INITIAL_MY_SUPERVISIONS,
    action: MySupervisionsAction
) => {
    switch (action.type) {
        case MySupervisionsActionType.GET_INVOLVED_PROJECTS:
            return action.payload['mySupervisions'] as MySupervisionsState;
        case MySupervisionsActionType.GET_MY_SUPERVISIONS:
            return action.payload as MySupervisionsState;
        case MySupervisionsActionType.DECLINE_PROJECT:
        case MySupervisionsActionType.APPROVE_PROJECT:
        case MySupervisionsActionType.REVIEW_PROJECT_CHANGES:
            return {
                projects: [
                    ...state.projects.map((project: ProjectModel) => {
                        const newP = action.payload as ProjectModel;
                        if (project._id === newP._id) {
                            return newP;
                        } else {
                            return project;
                        }
                    }),
                ],
            };
        default:
            return state;
    }
};

export default reducer;
